import React from 'react';
import styled from 'styled-components';
import versionImg from '../../images/common/i_version_on.svg';

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* 배경 살짝 더 진하게 */
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(4px);
    padding: var(--sp-16);
`;

const ModalBox = styled.div`
    width: 100%;
    max-width: 340px;
    background-color: #fff;
    border-radius: 20px;
    padding: var(--sp-32) var(--sp-20) var(--sp-32);
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    gap: var(--sp-16);
    align-items: center;
    text-align: center;
    box-sizing: border-box;
`;

const Title = styled.h2`
    font-size: var(--mo-fz-xlg);
    font-weight: 700;
    color: var(--color-main-black);
    line-height: 1.3;
    letter-spacing: -0.5px;
`;

const Content = styled.div`
    width: 100%;
`;

const Description = styled.p`
    font-size: var(--mo-fz-smd); 
    color: var(--color-main-gray);
    line-height: 1.5;
    word-break: keep-all;

    & .warning {
        color: var(--color-important); 
        font-weight: 700;
    }

    & .highlight {
        color: var(--color-main-5);
        font-weight: 600;
        display: block;
    }
`;

const VersionBadge = styled.div`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: var(--sp-08) var(--sp-20);
    background-color: var(--color-main-10);
    border-radius: 6px;
    margin-top: var(--sp-16);
    
    & span {
        font-size: var(--mo-fz-smd);
        color: var(--color-main-5);
        font-weight: 700;
    }
`;

const ButtonGroup = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: var(--sp-12);

    & button {
        width: calc((100% - var(--sp-12)) / 2);
    }
`;


const IconBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 75px;
    height: 75px;
    margin: 0 auto;
    background: var(--color-main-10);
    border-radius: 100%;
`;




const UpdateNoticeBox = ({ onClose, latestVersion, storeUrl }) => {

    const handleUpdate = () => {
        const targetUrl = storeUrl || 'https://play.google.com/store/apps/details?id=com.cmcnu.careplus';
        
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'OPEN_EXTERNAL_URL',
                url: targetUrl
            }));
        } else {
            window.open(targetUrl, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <Overlay>
            <ModalBox>

                <Title>서비스 업데이트 안내</Title>

                <IconBox>
                    <object data={versionImg} type=""></object>
                </IconBox>
                <Content>
                    <Description>
                        현재 사용 중인 버전에서는<br/>
                        <span className="warning">일부 기능이 제한</span>되거나<br/> 
                        오류가 발생할 수 있습니다.<br/>
                        <br/>
                        <span className="highlight">
                            안정적인 서비스 이용을 위해<br/>
                            최신 버전으로 업데이트 해주세요.
                        </span>
                    </Description>
                    
                    {latestVersion && (
                        <VersionBadge>
                            <span>최신 버전 v{latestVersion}</span>
                        </VersionBadge>
                    )}
                </Content>

                <ButtonGroup>
                    {onClose && (
                        <button className='btn' data-btn-type="fill-gray" data-btn-size='lg' onClick={onClose}>
                            <span>나중에</span>
                        </button>
                    )}
                    
                    <button className='btn' data-btn-type="fill-main" data-btn-size='lg' onClick={handleUpdate}>
                            <span>지금 업데이트</span>
                    </button>
                    
                </ButtonGroup>
            </ModalBox>
        </Overlay>
    );
};

export default UpdateNoticeBox;